// extracted by mini-css-extract-plugin
export default {"container":"expanded-order_container__2R74C","column":"expanded-order_column__W8Lh5","statistics":"expanded-order_statistics__xMbwp","spin":"expanded-order_spin__qJGc9"};